export enum DirectDebitFailedReason {
  LackOfFunds = 'Lack of funds / Insufficient funds',
  AccountClosed = 'Account closed',
  MandateMissing = 'Mandate missing',
  CustomerRefusedPayment = 'Customer refused payment',
  AccountBlocked = 'Account blocked',
  TechnicalError = 'Technical error',
  InvalidAccountNumber = 'Invalid account number',
  DirectDebitLimitExceeded = 'Direct debit limit exceeded',
  OtherReason = 'Other reason',
}

export const DIRECT_DEBIT_FAILED_REASONS = Object.values(DirectDebitFailedReason);
